import { defineComponent as _defineComponent } from 'vue'
import { getUrlParamByKey, UrlParamKey } from '@/utils/url-params-helper';
import { biClick } from '@tencent/fit-bi-sdk';
import ReturnUserCoupon from '@tencent/wphk-components-returning-user/components/return-user-coupon.vue';
import UseButton from '@tencent/wphk-components-returning-user/components/use-button.vue';
import { SimpleCouponAwardCodeMap } from '@tencent/wphk-components-returning-user/types';
import { PropType } from 'vue';
import { useBiReport } from '../hooks/use-report';
import { QrpayFromScene } from '@tencent/wphk-components-jump-page';


export default /*#__PURE__*/_defineComponent({
  __name: 'reward-result',
  props: {
  awardInfo: { type: Object as PropType<SimpleCouponAwardCodeMap>, required: true },
},
  setup(__props) {


const { biExt } = useBiReport();
const adTag = getUrlParamByKey(UrlParamKey.adtag);

const onClickUseButton = () => {
  biClick('userbackpage.usebtn_click', biExt.value);
};


return { __sfc: true,biExt, adTag, onClickUseButton, ReturnUserCoupon, UseButton, QrpayFromScene }
}

})